// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SSKJizdgQAACSPFMElws{flex-wrap:wrap;justify-content:space-between;gap:24px 12px;padding:30px 4px 40px;display:flex}.SSKJizdgQAACSPFMElws .QBCtkhpBam01xGqh8bxw{flex-direction:column;gap:4px;width:calc(50% - 6px);max-width:354px;display:flex}@media (max-width:478px){.SSKJizdgQAACSPFMElws .QBCtkhpBam01xGqh8bxw{width:100%;max-width:none}}.vmdsg0DMfB85pRbNTpUC{flex-direction:column;gap:32px;padding:31px 4px 32px;display:flex}.vmdsg0DMfB85pRbNTpUC .Avd6gCS7aGwSFHX3b1Ae{justify-content:space-between;align-items:center;display:flex}.vmdsg0DMfB85pRbNTpUC .Avd6gCS7aGwSFHX3b1Ae .cF_hRMuU46Ia3aJ0Y_2J{flex-direction:column;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formWrap": `SSKJizdgQAACSPFMElws`,
	"inputWrap": `QBCtkhpBam01xGqh8bxw`,
	"actionsWrap": `vmdsg0DMfB85pRbNTpUC`,
	"action": `Avd6gCS7aGwSFHX3b1Ae`,
	"label": `cF_hRMuU46Ia3aJ0Y_2J`
};
export default ___CSS_LOADER_EXPORT___;
